import { NotificationRecipients } from '../modules/notifications/shared/notification.model'

export interface NotificationAcknowledge {
  id: number
  status: NotificationAcknowledgeStatus
  comment: string
  recipients: NotificationRecipients
}

export enum NotificationAcknowledgeStatus {
  Open = 'open',
  InReview = 'in-review',
  Actioned = 'actioned',
}

export interface NotificationAcknowledgeHistory {
  id: number
  entityId: number
  createdAt: string
  createdByName: string
  payload: NotificationAcknowledgeHistoryPayload
}

export interface NotificationAcknowledgeHistoryPayload {
  status: NotificationAcknowledgeStatus
  comment: string
}

export const NotificationAcknowledgeStatusLabel: Record<NotificationAcknowledgeStatus, string> = {
  [NotificationAcknowledgeStatus.Open]: 'ALERTS.EVENTS_LOG.ACKNOWLEDGE.OPEN',
  [NotificationAcknowledgeStatus.InReview]: 'ALERTS.EVENTS_LOG.ACKNOWLEDGE.IN_REVIEW',
  [NotificationAcknowledgeStatus.Actioned]: 'ALERTS.EVENTS_LOG.ACKNOWLEDGE.ACTIONED',
}

export interface NotificationAcknowledgeDialogData {
  acknowledgeHistory: NotificationAcknowledgeHistory[]
  isPermissionForUpdating: boolean
}
